// material
import { styled } from '@material-ui/core/styles';
// components
import Page from '../components/Page';
import Approval from 'components/_external-pages/admin/Approval';
import DashboardNavbar from 'layouts/dashboard/DashboardNavbar';
import DashboardSidebar from 'layouts/dashboard/DashboardSidebar';
// import DataGrid from '../components/_external-pages/admin/Dashboard';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)({
  height: '100%'
});

const ContentStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function ApprovalPage() {
  return (
    <RootStyle title="Admin" id="move_top">
      <DashboardNavbar />
      <DashboardSidebar />
      <Approval />
        
    </RootStyle>
  );
}
